export class ReportConfigModel {
    constructor(obj) {
        this.period = '';
        this.name = '';
        this.target = '';
        this.cron = '';
        this.recipientList = '';
        this.id = '';
        this.rcSort = '';
        this.rcPart = '';
        this.status = ReportConfigStatuses.ACTIVE;
        
        if (obj) {
            const { recipients, ...rest } = obj;
            Object.assign(this, rest);

            if (Array.isArray(recipients) && recipients.length) {
                this.recipientList = recipients.filter(Boolean).join(',');
            }
        }

        // Own `recipients` would shadow the getter and keep stale values after edits.
        if (Object.prototype.hasOwnProperty.call(this, 'recipients')) {
            delete this.recipients;
        }

        if (!this.id) {
            this.id = this.rcSort;
        }
    }

    get recipients() {
        if (!this.recipientList) return [];
        return this.recipientList
            .split(',')
            .map((val) => val.trim())
            .filter(Boolean);
    }

    set recipients(values) {
        this.recipientList = Array.isArray(values) ? values.filter(Boolean).join(',') : values || '';
    }
}


export const ReportConfigEventType = {
    REPORT_VIEW: 'reportView',
    REPORT_EDIT: 'reportEdit',
    REPORT_ADD: 'reportAdd',
    REPORT_DELETE: 'reportDelete',
    REPORT_UNARCHIVE: 'reportUnarchive',
}


export const ReportConfigStatuses ={
    ACTIVE:'active',
    ARCHIVED:'archived',
}